import React from 'react';
import PropTypes from 'prop-types';
import { RichTextPropTypes } from '../../prop-types';
import RichText from '../rich-text';

import { combineToRichText } from './helpers';
import { Stat } from './styles';

const SingleStat = ({
  title,
  subtitle,
  text,
  statLayout,
  statIndex,
  rowIndex,
}) => {
  const combinedText = {
    raw: combineToRichText(title, subtitle, text?.raw),
    references: text && text?.references ? [...text.references] : [],
  };

  return (
    <Stat $statLayout={statLayout} $statIndex={statIndex} $rowIndex={rowIndex}>
      <RichText richText={combinedText} noWrapper />
    </Stat>
  );
};

SingleStat.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  text: RichTextPropTypes,
  statLayout: PropTypes.string.isRequired,
  statIndex: PropTypes.number.isRequired,
  rowIndex: PropTypes.number,
};

export default SingleStat;
